import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth, hasRole } from "@/lib/auth";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";
import BirthdayBanner from "@/components/BirthdayBanner";
import ErrorBoundary from "@/components/ErrorBoundary";
const TITLES = {
  "/dashboard": "Dashboard",
  "/products": "Ürünler",
  "/products/new": "Ürün Ekle",
  "/stock/entry": "Stok Girişi",
  "/stock/decrease": "Stok Düş",
  "/stock/movements": "Stok Hareketleri",
  "/stock/critical": "Kritik Stoklar",
  "/companies": "Firmalar",
  "/companies/new": "Firma Ekle",
  "/quotes": "Tekliflerim",
  "/quotes/new": "Teklif Hazırla",
  "/orders": "Siparişler",
  "/orders/new": "Sipariş Hazırla",
  "/cari": "Cari Takip",
  "/cari/movements": "Cari Hareketler",
  "/cari/aging": "Yaşlandırma Raporu",
  "/payments/new": "Ödeme Girişi",
  "/reports/stock": "Stok Raporları",
  "/reports/sales": "Satış Raporları",
  "/reports/cari": "Cari Raporları",
  "/reports/sales-companies": "Satış Personeli Firma Raporu",
  "/definitions/categories": "Kategoriler",
  "/definitions/brands": "Markalar",
  "/definitions/service-areas": "Hizmet Alanları",
  "/personnel": "Personeller",
  "/assignments": "Personel Zimmet Listesi",
  "/ecommerce/sales": "E-Ticaret Satışları",
  "/ecommerce/sales/new": "E-Ticaret Satışı Ekle",
  "/definitions/marketplaces": "E-Ticaret Pazaryerleri",
  "/purchase-orders": "Satın Alma Siparişleri",
  "/purchase-orders/new": "Yeni Satın Alma Siparişi",
  "/productions": "Üretim",
  "/notifications": "Bildirimler",
  "/settings": "Ayarlar",
};

export default function Layout({ allowedRoles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F6F8FB]">
        <div className="text-[#08285A] font-semibold">Yükleniyor...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (allowedRoles && !hasRole(user, ...allowedRoles)) {
    return <Navigate to="/dashboard" replace />;
  }

  const title = TITLES[loc.pathname] ||
    Object.entries(TITLES).find(([k]) => loc.pathname.startsWith(k))?.[1] ||
    "AZD Flow";

  return (
    <div className="min-h-screen flex bg-[#F6F8FB]">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar title={title} />
        <main className="flex-1 p-5 lg:p-8 azd-fade-up">
          <BirthdayBanner />
          <ErrorBoundary key={loc.pathname}>
            <Outlet key={loc.pathname} />
          </ErrorBoundary>
        </main>
        <footer
          className="px-5 lg:px-8 py-4 border-t border-[#E5E7EB] bg-white text-center text-[11px] text-[#6B7280]"
          data-testid="app-footer"
        >
          Bu şirket yönetim sistemi{" "}
          <a
            href="https://www.dijitalroket.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="dijitalroket-link"
            className="font-bold text-[#0B3676] hover:text-[#08285A] hover:underline transition-colors"
          >
            Dijital Roket
          </a>{" "}
          tarafından geliştirilmiştir.
        </footer>
      </div>
    </div>
  );
}
